import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Page from "src/components/Page";
import AboutUs from "./About";

function index(props) {
  localStorage.removeItem("@storeAuctionLot");



  return (
   

    <Page title='About Us Leon Gallery | Philippine Art, History & Vision'>
      <AboutUs />
    </Page>

  );
}

export default index;
